import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { Grid } from '@mui/material';
import { DialogContentText, Tooltip } from '@material-ui/core';
import Input from '../../../../components/Input/Input'
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';

let width

const Allowance = ({
    open,
    typesAllowaces,
    observationsAllowance,
    typesReduce,
    typesHome,
    onClose,
    handleInputTimeAndHoraryAllowance,
    setJustificationChange,
    dateAllowance,
    horaryAllowance,
    justificationChange,
    setValueAllowance,
    valueAllowance,
    handleAllowanceClick,
    row,
    setRuleDECLARATION_ATTENDANCE,
    ruleDECLARATION_ATTENDANCE,
    setRuleHOME_OFFICE,
    ruleHOME_OFFICE,
    dtTo,
    dtFrom,
    deleteVacations,
}) => {

    const widthMapping = {
        LEAVE_OF_ABSENCE: '340px',
        SUNDAY_OR_HOLIDAY_COMPENSATION: '400px',
        ALLOWANCE_HOURS: '400px',
        JUSTIFIED_DELAY: '400px',
        OUTPUT_SERVICE: '400px',
        DECLARATION_ATTENDANCE: '450px',
        MISSING_TIME: '400px',
        HOME_OFFICE: '400px',
        CHANGE_DAY: '400px',
        VACATION: '400px',
        INTERJOURNEY_PER_DAY: '400px',
        default: '320px', // Valor padrão para todos os outros casos
    };

    width = widthMapping[valueAllowance] || widthMapping.default;
    const specialValues = ['SUNDAY_OR_HOLIDAY_COMPENSATION', 'ALLOWANCE_HOURS', 'JUSTIFIED_DELAY', 'OUTPUT_SERVICE', 'DECLARATION_ATTENDANCE', 'MISSING_TIME', 'CHANGE_DAY'];
    const timeAndDatePicker = specialValues.includes(valueAllowance)
    const specialTimePicker = ['ALLOWANCE_HOURS', 'JUSTIFIED_DELAY', 'OUTPUT_SERVICE', 'DECLARATION_ATTENDANCE', 'MISSING_TIME']

    const [pointPre, setPointPre] = useState(false)

    const handlePoinrPre = () => {
        setPointPre(true)
    }
    const closeHandlePointPre = () => {
        setPointPre(false)
    }

    const [disabled, setDisabled] = useState(false)
    const [messageDisabled, setMessageDisabled] = useState('')
    const [justification, setJustification] = useState('')

    const updateAllowance = (e) => {
        setValueAllowance(e.target.value)
        setDisabled(false)
        setMessageDisabled('')
    }

    const handleJustificationChange = (e) => {
        const value = e.target.value;
        if (row?.allowanceData?.length == 0) {
            if (!value) {
                return setMessageDisabled('O campo observação é obrigatório.');
            }
        }
        setDisabled(false)
        setMessageDisabled('')
        handleInputTimeAndHoraryAllowance(value, 'observation')
        setJustification(value)
    };

    const handleDeleteAllowance = async () => {
        try {
            return await deleteVacations(row)
        } catch (error) {
            console.error(error)
        }
    }

    const handleClick = () => {
        if (row?.allowanceData?.length == 0 && valueAllowance !== 'LEAVE_OF_ABSENCE'? !justification : !justificationChange && valueAllowance !== 'LEAVE_OF_ABSENCE') {
            setDisabled(true)
            return setMessageDisabled('O campo observação é obrigatório.')
        }

        setDisabled(false)
        setMessageDisabled('')
        setJustification('')
        handleAllowanceClick(row)
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth="md"
                PaperProps={{
                    style: styles.DialogPaper
                }}
                scroll='paper'
            >
                <div>
                    <DialogTitle style={styles.DialogTitle}>
                        {row?.allowanceData?.length > 0 ? 'Editar abono' : 'Cadastrar abono'}
                    </DialogTitle>
                    {row?.allowanceData?.length > 0 ?
                        <Tooltip title="Excluir abono" arrow>
                            <Button
                                onClick={handleDeleteAllowance}
                                style={{
                                    display: 'flex',
                                    marginLeft: '160%',
                                    marginTop: '-60px',
                                    color: '#484fdb'
                                }}
                            >
                                <DeleteIcon>
                                </DeleteIcon>
                            </Button>
                        </Tooltip>
                        : null}
                </div>


                <FormControl
                    style={styles.Select}
                >
                    <Select
                        style={styles.SelectTypes}
                        value={valueAllowance}
                        defaultValue={'Type'}
                        onChange={updateAllowance}
                    >
                        {typesAllowaces.map((allowance, index) => (
                            <MenuItem key={index} value={allowance.value}>
                                {allowance.displayValue}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {
                    valueAllowance == 'INTERJOURNEY_PER_DAY' ?
                        <Button
                            variant="text" // ou "contained" ou "outlined" dependendo do estilo desejado
                            style={styles.botomInterjoney}
                            onClick={handlePoinrPre}
                        >
                            O que é Ajuste de Interjornada
                            <Paper
                                style={styles.Interjoney}
                            >
                                <QuestionMarkIcon
                                    style={{ padding: '3px', color: '#fff' }}
                                />
                            </Paper>
                        </Button>
                        : null
                }

                <Dialog
                    open={pointPre}
                    onClose={closeHandlePointPre}
                    PaperProps={{
                        style: styles.DialogNotification
                    }}

                >
                    <div style={{ display: 'flex' }}>
                        <DialogTitle style={styles.DialogTitleInterjoney}>
                            <Typography variant="body1" style={styles.textTitleInterjoney}>Ajuste de Interjornada</Typography>
                        </DialogTitle>
                        <div style={{ marginLeft: '8em', marginTop: '1em' }}>
                            <Paper style={styles.paperInterjoney}>
                                <CloseIcon
                                    style={{ padding: '3px', color: '#4851de' }}
                                    onClick={closeHandlePointPre}
                                />
                            </Paper>
                        </div>
                    </div>
                    <DialogContent>
                        <Typography variant="body1" style={styles.textInterjoney}>
                            Utilize esta função para ajustar casos<br />
                            em que o tempo de trabalho durante a interjornada<br />
                            precisa ser transferido para o próximo dia.<br />
                            O sistema permitirá a transferência do tempo de<br />
                            trabalho excedente da hora extra para o dia seguinte de<br />
                            maneira simples e rápida. Certifique-se de revisar e<br />
                            confirmar as alterações antes de aplicar. <br />
                            Esta ferramenta oferece flexibilidade na gestão<br />
                            dos registros de trabalho, possibilitando a adequação<br />
                            às necessidades específicas da empresa.
                        </Typography>
                    </DialogContent>
                    <br />
                </Dialog>


                {valueAllowance == 'DECLARATION_ATTENDANCE' ?
                    (<FormControl
                        style={styles.DECLARATION_ATTENDANCE}
                    >
                        <InputLabel id="demo-simple-select-label" style={{ color: '#212121', marginTop: '-8px' }}>Selecione...</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={styles.SelectDECLARATION_ATTENDANCE}
                            value={ruleDECLARATION_ATTENDANCE}
                            onChange={(event) => setRuleDECLARATION_ATTENDANCE(event.target.value)}
                        >
                            {typesReduce.map((allowance, index) => (
                                <MenuItem key={index} value={allowance.value}>
                                    {allowance.displayValue}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>)
                    : null
                }
                {valueAllowance == 'HOME_OFFICE' ?
                    (<FormControl
                        style={styles.HOME_OFFICE}
                    >
                        <InputLabel id="demo-simple-select-label" style={{ color: '#212121', marginTop: '-8px' }}>Selecione...</InputLabel>
                        <Select
                            style={styles.SelectHomeOffice}
                            value={ruleHOME_OFFICE}
                            onChange={event => setRuleHOME_OFFICE(event.target.value)}
                        >
                            {typesHome.map((allowance, index) => (
                                <MenuItem key={index} value={allowance.value}>
                                    {allowance.displayValue}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>)
                    : null
                }
                {
                    timeAndDatePicker ?
                        <FormControl
                            style={styles.FormControl}
                        >
                            {
                                specialTimePicker.includes(valueAllowance) ?
                                    <Input
                                        elementType="timePicker"
                                        // style={{ marginRight: '40px' }}
                                        label={"Horas abonadas"}
                                        margin="normal"
                                        value={horaryAllowance || null}
                                        onChange={event => handleInputTimeAndHoraryAllowance(event, 'allowanceHours')}
                                    /> :
                                    <Input
                                        elementType="datePicker"
                                        label={valueAllowance == 'CHANGE_DAY' ? "Troca de folga" : "Domingo/feriado trabalhado"}
                                        margin="normal"
                                        style={{ borderRadius: '20px' }}
                                        value={dateAllowance || null}
                                        onChange={event => handleInputTimeAndHoraryAllowance(event, 'compensationDate')}
                                    />
                            }
                        </FormControl> : null
                }

                {
                    valueAllowance == 'LEAVE_OF_ABSENCE' ?
                        (<FormControl
                            style={styles.LEAVE_OF_ABSENCE}
                        >
                            <Select
                                style={styles.SelectLEAVE_OF_ABSENCE}
                                value={justificationChange}
                                onChange={event => handleInputTimeAndHoraryAllowance(event.target.value, 'observation')}
                            >
                                {observationsAllowance.map((allowance, index) => (
                                    <MenuItem key={index} value={allowance.value}>
                                        {allowance.displayValue}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>)
                        :
                        null
                }


                {/* </DialogContent> */}
                <DialogContent style={{ marginTop: '-3%' }} >
                    {
                        valueAllowance == 'LEAVE_OF_ABSENCE' ?
                            null :
                            <>
                                <TextField
                                    id="outlined-basic"
                                    label="Observação"
                                    variant="outlined"
                                    value={justificationChange}
                                    sx={{
                                        "& .MuiOutlinedInput-notchedOutline": { borderTop: "none", borderLeft: "none", borderRight: "none" },
                                        "& .MuiInputLabel-outlined": { marginLeft: '-14px', marginTop: '10px', color: '#757575' } // Adicione esta linha
                                    }}
                                    style={{ width: '480px', marginTop: '5px' }}
                                    onChange={handleJustificationChange}
                                />
                                <Typography
                                    style={{ marginLeft: '2%', marginTop: '4%', color: 'red' }}
                                >
                                    {messageDisabled}
                                </Typography>
                            </>
                    }
                    {
                        valueAllowance == 'VACATION' ?
                            <>

                                <Input
                                    elementType="datePicker"
                                    label={"Início do periodo"}
                                    margin="normal"
                                    style={styles.Input}
                                    value={dtFrom || null}
                                    onChange={event => handleInputTimeAndHoraryAllowance(event, 'dtFrom')}
                                />
                                <Input
                                    elementType="datePicker"
                                    label={"Fim do periodo"}
                                    margin="normal"
                                    style={styles.Input}
                                    value={dtTo || null}
                                    onChange={event => handleInputTimeAndHoraryAllowance(event, 'dtTo')}
                                />
                            </>
                            :
                            null
                    }

                    <Grid container direction="row" alignItems="center" justifyContent="center" style={styles.gridButtom}>
                        <Grid item>
                            <Button
                                onClick={handleClick}
                                variant="contained"
                                style={styles.buttomConfirmation}
                                disabled={disabled}
                            >
                                Confirmar
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                style={styles.buttomClose}
                                onClick={onClose}
                            >
                                Fechar
                            </Button>
                        </Grid>
                    </Grid>

                </DialogContent>
            </Dialog >
        </>
    )
}

export default Allowance;

const styles = {
    DialogPaper: {
        backgroundColor: 'white',
        borderRadius: '20px',
        width: '600px',
        height: width,
        textAlign: 'center',
        alignItems: 'center'
    },
    DialogTitle: {
        fontSize: '22px',
        marginTop: '4%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '10px 0px',
    },
    Select: {
        display: 'flex',
        justifyContent: 'center',
        width: '80%',
        maxWidth: '500px', // Defina a largura máxima desejada
        borderRadius: '20px',
        marginTop: '10px'
    },
    SelectTypes: {
        borderRadius: '30px',
        padding: '0px 10px',
        height: '40px',
    },
    botomInterjoney: {
        color: '#4851de',
        display: 'flex',
        marginTop: '1em',
    },
    Interjoney: {
        display: 'inline-flex',
        borderRadius: '50%',
        backgroundColor: '#4851de',
        marginLeft: '0.5em',
    },
    DialogNotification: {
        borderRadius: '30px',
        color: 'white',
        backgroundColor: '#4851de',
        alignItems: 'center'
    },
    DialogTitleInterjoney: {
        textAlign: 'center',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center'
    },
    textTitleInterjoney: {
        textAlign: 'center',
        fontSize: '16px',
        whiteSpace: 'nowrap',
        fontWeight: 'bold'
    },
    paperInterjoney: {
        display: 'inline-flex',
        borderRadius: '50%',
        backgroundColor: '#fff',
    },
    textInterjoney: {
        textAlign: 'left',
        fontSize: '12px',
        fontWeight: 'bold',
        marginLeft: '10px',
        marginRight: '10px'
    },
    DECLARATION_ATTENDANCE: {
        display: 'flex',
        justifyContent: 'center',
        width: '80%',
        maxWidth: '500px', // Defina a largura máxima desejada
        borderRadius: '20px',
        // marginLeft: '10%',
        marginTop: '6%'
    },
    SelectDECLARATION_ATTENDANCE: {
        borderRadius: '30px',
        padding: '0px 10px',
        height: '40px',
    },
    HOME_OFFICE: {
        display: 'flex',
        justifyContent: 'center',
        width: '80%',
        maxWidth: '500px', // Defina a largura máxima desejada
        borderRadius: '20px',
        // marginLeft: '10%',
        marginTop: '6%'
    },
    SelectHomeOffice: {
        borderRadius: '30px',
        padding: '0px 10px',
        height: '40px',
    },
    FormControl: {
        display: 'flex',
        justifyContent: 'center',
        width: '80%',
        maxWidth: '480px', // Defina a largura máxima desejada
        borderRadius: '20px',
        // marginLeft: '10%',
    },
    LEAVE_OF_ABSENCE: {
        display: 'flex',
        justifyContent: 'center',
        width: '80%',
        maxWidth: '500px', // Defina a largura máxima desejada
        borderRadius: '20px',
        // marginLeft: '10%',
        marginTop: '6%'
    },
    SelectLEAVE_OF_ABSENCE: {
        borderRadius: '30px',
        padding: '0px 10px',
        height: '40px',
    },
    Input: {
        borderRadius: '20px',
        width: '40%',
        // marginLeft: '5%'
    },
    buttomConfirmation: {
        backgroundColor: '#4851de',
        color: 'white',
        borderRadius: '20px',
        // marginLeft: '10.5%',
        height: '50px',
        marginTop: '6%',
        width: '10em'
    },
    buttomClose: {
        backgroundColor: 'white',
        color: '#4851de',
        borderRadius: '20px',
        // marginLeft: '1.5%',
        height: '50px',
        marginTop: '6%',
        width: '10em',
        border: '1px solid #4851de',
        marginLeft: '1em'
    },
    gridButtom: {
        display: 'flex',
        marginTop: '1em'
    }
}